import React, { Component } from "react";
import styled from "styled-components";
import { graphql, compose } from "react-apollo";
import { queryGetMe, mutationUpdateOnlineStatus } from "Apollo";
import { ShowNotice } from "Store";
import Avatar from "module-common/Avatar";
import Icon from "module-common/Icon";
import Picker from "./PickerStatusWithQuery";

export default compose(
  graphql(mutationUpdateOnlineStatus),
  graphql(queryGetMe)
)(
  class Header extends Component {
    render() {
      const data = this.props.data;
      const me = data.me;
      if (!me) return null;

      const agent = me.agent;
      return (
        <Wrapper>
          <Avatar
            isSmall
            image={agent.displayPicture}
            status={agent.onlineStatus.onlineStatusType.name}
          />
          <Info>
            <Name>{agent.displayName}</Name>
            <Picker onSelected={this.onChangeStatus}>
              <Status>
                <P>{agent.onlineStatus.onlineStatusType.displayName}</P>
                <Icon name="arrow-down-white" width={11} height={19} />
              </Status>
            </Picker>
          </Info>
        </Wrapper>
      );
    }

    onChangeStatus = selected => {
      const data = this.props.data;
      const me = data.me;
      if (!me) return null;

      try {
        this.props.mutate({
          variables: {
            agent: {
              id: me.agent.id
            },
            onlineStatusTypeInput: {
              id: selected.value.id
            }
          },
          refetchQueries: ["getMe"]
        });
        ShowNotice("online-status-update-success");
      } catch (error) {
        ShowNotice("online-status-update-error");
      }
    };
  }
);

const Wrapper = styled.div`
  display: flex;
  flex: none;
  height: 55px;
  background-color: ${props => props.theme.sidemenuBackground};
  border-radius: 4px 4px 0 0;
  color: white;
  align-items: center;
  padding: 0 12px;
`;
const Info = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 12px;
`;
const Name = styled.div`
  font-weight: bold;
`;
const Status = styled.div`
  font-size: 0.75rem;
  border-radius: 3px;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`;
const P = styled.span`
  margin-right: 4px;
`;



// WEBPACK FOOTER //
// ./src/module-sidemenu/online-status/HeaderWithQueryMutation.js